import Modal from '~/components/Modal';
import { Button } from '~/components';
import { useSubmitPortfolio } from '~/mutations/portfolio/useSubmitPortfolio';

interface StandaloneProjectModalProps {
  closeModal: () => void;
  handleSubmit: () => void;
}

const StandaloneProjectModal = ({
  closeModal,
  handleSubmit
}: StandaloneProjectModalProps  
) => {
  const { status: submitPortfolioStatus } = useSubmitPortfolio();
  
  return (
    <>
      <Modal.Title>Project submission</Modal.Title>
      <Modal.Content>
        <p>This portfolio contains a single project.</p>
        <p style={{ fontWeight: '700' }}>
          By clicking the confirm button below, you acknowledge that the portfolio will be removed and the project will be submitted on its own.
        </p>
      </Modal.Content>
      <Modal.Footer>
        <Button 
          primary
          onClick={() => handleSubmit()}
          loading={submitPortfolioStatus === 'loading'}
          disabled={submitPortfolioStatus === 'loading'}
        >
          Confirm
        </Button>
        <Button 
          primary
          outlined 
          onClick={closeModal}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </>
  );
};

export default StandaloneProjectModal;